<template>
    <div class="ui-page">
        <ui-page-header title="Documentos" subtitle="Documentos publicados nos casos.">
            <v-btn v-if="$allowed('create')" id="btnNew" type="button" color="primary" depressed to="/documentos/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field dense id="name" placeholder="Buscar pelo nome" v-model="dataList.filter.name" hide-details
                    outlined prepend-inner-icon="mdi-magnify" class="ui-toolbar__search" @input="filterDebounced"
                    @keyup.enter="applyFilters"></v-text-field>
                <v-autocomplete dense :items="dataset.clients" placeholder="Todos os casos" v-model="dataList.filter.client"
                    item-value="id" item-text="name" outlined hide-details no-data-text="Nenhum caso encontrado"
                    class="ui-toolbar__field" :menu-props="{ offsetY: true }" @change="applyFilters">
                </v-autocomplete>
                <v-select dense :items="dataset.clientDocTypes" placeholder="Todos os tipos"
                    v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                    hide-details class="ui-toolbar__field" :menu-props="{ offsetY: true }" @change="applyFilters">
                </v-select>
            </template>

            <v-data-table :headers="dataList.headers" 
                :items="dataList.data"
                :server-items-length="dataList.count" 
                disable-sort
                hide-default-footer
                :loading="dataList.loading"
                no-data-text="Nenhum documento foi encontrado" 
                loading-text="Carregando dados..."
                :options.sync="dataList.options"
                class="ui-clickable-rows"
                @click:row="openRow">

                <template v-slot:[`item.name`]="{ item }">
                    <span class="ui-cell-main">{{ item.name }}</span>
                </template>

                <template v-slot:[`item.created_at`]="{ item }">
                    {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                </template>

                <template v-slot:[`item.type`]="{ item }">
                    {{ item.type | enum(dataset.clientDocTypes, "id", "name") }}
                </template>

                <template v-slot:[`item.client`]="{ item }">
                    {{ item.client && item.client.name ? item.client.name : 'N/A' }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Editar', icon: 'mdi-pencil-outline', disabled: !$check('Document', 'PATCH'), handler: () => viewItem(item) },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, disabled: !$check('Document', 'DELETE'), handler: () => deleteItem(item) },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.size"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import clientDocTypes from "@/common/data/client-doc-types.data"

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "ClientDocList",

    data: () => ({
        dataset: {
            categories: [],
            clientDocTypes: [{ id: "", name: "Todos: " }, ...clientDocTypes],
            data: {},
            clients: [{ id: null, name: "Todos: " }]
        },
        dataList: {
            filter: {
                name: "",
                type: "",
                client: ""
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Caso", value: "client" },
                { text: 'Tipo', value: "type" },
                { text: "Criado em", value: "created_at" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    computed: {
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {
        this.load();
        this.loadClients();
    },

    methods: {
        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { name: "", type: "", client: "" };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.size = size;
        },

        // clientPageText() {
        //     return `${this.dataList.paging.page} de ${this.dataList.paging.pages}`;
        // },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/admin/client-docs', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data
                
                data.sort((a, b) => a.name.localeCompare(b.name));
                
                this.dataset.clients = [{ id: "", name: "Todos: " }, ...data];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        // A linha abre o detalhe so com a mesma permissao do "Editar".

        openRow(item) {

            if (this.$check('Document', 'GET')) this.viewItem(item);

        },


        viewItem(item) {
            this.$router.push(`documentos/${item.id}`);
        },

        async deleteItem(item) {
            
            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/client-docs/${item.id}`)

                this.$dialog.notify.info("Documento excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>
